import React from 'react';
import { connect } from 'react-redux';
import Movable from '../HOCs/Movable';
import toolboxElementFactory from '../toolbox-element-factory';

import styles from '../../../../stylesheet/css/header-builder/toolbox.css';

let Toolbox = React.createClass({
  getInitialState() {
    return {
      collapsed: true
    };
  },

  toggleCollapsed() {
    this.setState({
      collapsed: !this.state.collapsed
    });
  },

  render() {
    const { elements } = this.props,
          { collapsed } = this.state,
          className = styles.wrapper;

    return (
      <div className={className} draggable="false">
        <div className={styles.list}>
          <div className={styles.body}>
            {elements.map((el, index) => {
              // Only allow these elements for now.
              if (el.type == "row" || el.type == "image" || el.type == "logo") {
                const ToolboxElement = toolboxElementFactory(el.type);
                return <ToolboxElement key={index} {...el} />;
              }
            })}
          </div>
        </div>
      </div>
    );
  }
});
//<div className={styles.plusButton} onClick={this.toggleCollapsed} />

const mapStateToProps = (state) => {
  const { elements } = state.viewModel.toolbox;

  return {
    elements
  };
};

Toolbox = Movable({
  handlers: [
    `.${styles.titlebar}`,
    `.${styles.plusButton}`
  ]
})(Toolbox);

export { Toolbox };

export default connect(
  mapStateToProps
)(Toolbox);



// WEBPACK FOOTER //
// ./app/header-builder/components/Toolbox.js